<template>
    <div class="content">
        <jabra-breadcrumbs></jabra-breadcrumbs>
        <div class="centered-section">
            <div class="header">{{l10nYourCart}}</div>
        </div>
        <div class="centered-section">
            <div class="divider"></div>
        </div>
        <div v-if="cart">
            <div v-if="cart.length">
                <div class="sub-header">{{l10nYourOrder}}</div>
                <div class="data-area">
                    <div class="cart-section">
                        <table class="cart-items">
                            <tr class="header-row">
                                <td class="item-column">{{l10nItem}}</td>
                                <td class="details-column">{{l10nDetails}}</td>
                                <td class="variant-column"></td>
                                <td>{{l10nPricePerUnit}}</td>
                                <td>{{l10nQuantity}}</td>
                                <td>{{l10nPrice}}</td>
                                <td>{{l10nRemove}}</td>
                            </tr>
                            <tr v-for="(product, index) in cart">
                                <td class="item-column">{{category(product.item)}}</td>
                                <td class="details-column">
                                    <span v-if="!isSiddur(product)">{{product.name}}</span>
                                </td>
                                <td class="variant-column">
                                    <span v-if="isDigitalTalmud(product)">{{product.variant}}</span>
                                    <div v-else>
                                        <div class="dropdown-container">
                                            <jabra-dropdown :data="variantLabels(product)"
                                                            :mode="dropdownCartMode"
                                                            :initial-selected-item="product.variant"
                                                            v-on:jbr-select="updateVariant(index, product, $event)"></jabra-dropdown>
                                        </div>
                                    </div>
                                </td>
                                <td>{{product.unitPrice}}</td>
                                <td>
                                    <div v-if="!isDigitalTalmud(product)">
                                        <div class="stepper-container">
                                            <div>
                                                <jabra-stepper
                                                        v-on:sfr-stepper-change="updateQuantity(index, $event)"
                                                        :initial-value="product.quantity"
                                                        :mode="stepperCartMode"></jabra-stepper>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>{{product.totalPrice}}</td>
                                <td class="remove-column">
                                    <span class="remove" v-on:click="removeFromCart(index)">X</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="checkout-section">
                        <div class="checkout-inner-section">
                            <div class="totals-section">
                                <div class="subtotal-section">
                                    <div class="subtotal-label-section">
                                        <span>{{l10nTotalBug}}:</span>
                                    </div>
                                    <div class="value-section">
                                        <span>{{totalQuantity}} {{l10nItems}}</span>
                                        <span>{{totalPrice}}$</span>
                                    </div>
                                </div>
                                <div class="total-section">
                                    <div class="total-label-section">
                                        <span>{{l10nTotal}}:</span>
                                    </div>
                                    <div class="total-sublabel-section">
                                        <span>({{l10nNotIncludingDelivery}})</span>
                                    </div>
                                    <div class="value-section">
                                        <span>{{totalQuantity}} {{l10nItems}}</span>
                                        <span>{{totalPrice}}$</span>
                                    </div>
                                </div>
                            </div>
                            <div class="actions-section">
                                <jabra-btn dark>
                                    <span class="checkout-btn-span">{{l10nSecureCheckout}}</span>
                                </jabra-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="centered-section">
                    <div class="sub-header">{{l10nYourCartIsEmpty}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        CATEGORY_DIGITAL_TALMUD,
        CATEGORY_TALMUD,
        CATEGORY_SIDDUR,
        LOADING_STARTED,
        REMOVE_FROM_CART_BY_INDEX,
        UPDATE_PRODUCT_QUANTITY_BY_INDEX,
        UPDATE_PRODUCT_VARIANT_BY_INDEX,
        STEPPER_CART_MODE,
        DROPDOWN_CART_MODE,
    } from '../services/constants'
    import helpers from '../services/helpers'

    export default {
        name: 'cart-component',
        data: function () {
            return {
                LOADING_STARTED: LOADING_STARTED,
                expanded: [],
                quantities: {},
                variants: {},
            }
        },
        computed: {
            cart() {
                return this.$store.state.commerceModule.cart.data.map(item => {
                    item.totalPrice = item.unitPrice * item.quantity
                    return item
                })
            },
            storeCommerceModule() {
                return this.$store.state.commerceModule
            },
            language() {
                return this.$store.state.languageModule.currentLanguage
            },
            totalQuantity() {
                return this.cart.map(item => {
                    return item.quantity
                }).reduce(this.addReducer)
            },
            totalPrice() {
                return this.cart.map(item => {
                    return item.totalPrice
                }).reduce(this.addReducer)
            },
            categoryTalmud() {
                return 'Talmud'
            },
            categoryDigitalTalmud() {
                return 'Digital Talmud'
            },
            categorySidder() {
                return 'Sidur'
            },
            stepperCartMode() {
                return STEPPER_CART_MODE
            },
            dropdownCartMode() {
                return DROPDOWN_CART_MODE
            },
            l10nYourCart() {
                return this.l10nGetter('your_cart')
            },
            l10nYourOrder() {
                return this.l10nGetter('your_order')
            },
            l10nItem() {
                return this.l10nGetter('item')
            },
            l10nDetails() {
                return this.l10nGetter('details')
            },
            l10nPricePerUnit() {
                return this.l10nGetter('price_per_unit')
            },
            l10nQuantity() {
                return this.l10nGetter('quantity')
            },
            l10nPrice() {
                return this.l10nGetter('price')
            },
            l10nRemove() {
                return this.l10nGetter('remove')
            },
            l10nTotalBug() {
                return this.l10nGetter('total_bug')
            },
            l10nItems() {
                return this.l10nGetter('items')
            },
            l10nTotal() {
                return this.l10nGetter('total')
            },
            l10nNotIncludingDelivery() {
                return this.l10nGetter('not_including_delivery')
            },
            l10nSecureCheckout() {
                return this.l10nGetter('secure_checkout')
            },
            l10nYourCartIsEmpty() {
                return this.l10nGetter('you_cart_is_empty')
            },


        },
        watch: {
            language(newVal) {
                this.init()
            }
        },
        methods: {
            addReducer(accumulator, currentValue) {
                return accumulator + currentValue
            },
            variantLabels(product) {
                const productId = product.productId
                const productList = product.item === CATEGORY_SIDDUR ?
                    this.storeCommerceModule.bookProducts : this.storeCommerceModule.talmudProducts
                const productEntity = productList.data.find(entity => {
                    return entity.id === productId
                })
                return helpers.variantLabels(productEntity)
            },
            removeFromCart(index) {
                this.$store.commit(REMOVE_FROM_CART_BY_INDEX, index)
            },
            category(categoryState) {
                switch (categoryState) {
                    case CATEGORY_DIGITAL_TALMUD:
                        return this.categoryDigitalTalmud
                    case CATEGORY_TALMUD:
                        return this.categoryTalmud
                    case CATEGORY_SIDDUR:
                        return this.categorySidder
                    default:
                        return this.categoryDigitalTalmud
                }
            },
            isSiddur(product) {
                return product.item === CATEGORY_SIDDUR
            },
            isDigitalTalmud(product) {
                return product.item === CATEGORY_DIGITAL_TALMUD
            },
            updateQuantity(index, quantity) {
                this.$store.commit(UPDATE_PRODUCT_QUANTITY_BY_INDEX, {
                    index: index,
                    quantity: quantity,
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            updateVariant(index, product, variant) {
                const productId = product.productId
                const productList = product.item === CATEGORY_SIDDUR ?
                    this.storeCommerceModule.bookProducts : this.storeCommerceModule.talmudProducts
                const productEntity = productList.data.find(entity => {
                    return entity.id === productId
                })
                const variantEntity = productEntity.variant.find(eachVariant => {
                    return eachVariant.short_name === variant
                })
                this.$store.commit(UPDATE_PRODUCT_VARIANT_BY_INDEX, {
                    index: index,
                    variant: variant,
                    unitPrice: variantEntity.price,
                })
            },
            // navigateToTalmudItem(product) {
            //     this.$router.push({name: 'storeTalmudItem', params: {id: `${product.id}`}})
            // },
            init() {
                if (this.language) {
                }
            }
        },
        created() {
            this.init()
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        padding: 70px 245px 130px;
    }

    .centered-section {
        display: flex;
        justify-content: center;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
    }

    .sub-header {
        @include font-abraham(30px, $font-color-blue, 300);
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .data-area {
        display: flex;
    }

    .cart-section {
        flex-grow: 9;
    }

    .checkout-section {
        flex-grow: 1;
        background: $accent-2-alpha;
        margin: 25px;
    }

    .checkout-inner-section {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }

    .total-section, .subtotal-section, .actions-section {
        margin: 30px;
    }

    .subtotal-section {
        padding: 0 0 40px 0;
        border-bottom: $grey-3 solid 1px;
    }

    .product-container {
        margin: 0 0 27px 0;
        border-left: $accent-1 solid 1px;
        box-shadow: 0 1px 13px 0 $grey-3;
        background: white;
    }

    table.cart-items {
        border-collapse: collapse;
        width: 100%;
        text-align: center;
        @include font-abraham(18px, $grey-1, 400);

        tr:not(.header-row) {
            $cart-row-border: $grey-3 solid 1px;
            border-top: $cart-row-border;
            border-bottom: $cart-row-border;
        }

        .header-row {
            @include font-abraham(18px, $grey-1, 300);
            .item-column {
                @include font-abraham(18px, $grey-1, 300);
            }
            .details-column {
                font-weight: 300;
            }
        }

        .item-column, .details-column, .variant-column {
            text-align: left;
        }

        .item-column {
            @include font-abraham(24px, $font-color-blue, 700);
        }

        .variant-column {
            @include font-abraham(15px, $grey-1, 300);
        }

        .remove-column {
            @include font-abraham(15px, $grey-1, 300);
            span.remove {
                cursor: pointer;
                font-size: 24px;
                padding: 5px 10px;
                &:hover {
                    color: $accent-1;
                }
            }
        }

        td {
            line-height: 73px;
        }
    }

    .stepper-container {
        display: flex;
        justify-content: center;
        padding: 5px;
    }

    .dropdown-container {
    }

    .subtotal-label-section {
        @include font-abraham(20px, $font-color-blue, 400);
        padding: 0 0 40px 0;
    }

    .value-section {
        @include font-abraham(22px, $grey-1, 400);
        display: flex;
        justify-content: space-between;
    }

    .total-label-section {
        @include font-abraham(40px, $font-color-blue, 400);
    }

    .total-sublabel-section {
        @include font-abraham(15px, $grey-1, 400);
        padding: 0 0 40px 0;

    }

    .actions-section {
        display: flex;
        justify-content: center;
    }

    .checkout-btn-span {
        @include font-abraham(20px, white, 400);
        line-height: 50px;
        padding: 50px;
    }
</style>
